import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const companyPriceListLocaleModule: LocaleModule = {
  name: "companyPriceList",
  messages: { en: en, it: it },
};
